import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { API } from '../config';

const AboutSection = () => {
    const [about, setAbout] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAbout = async () => {
            try {
                const response = await axios.get(`${API}/about`);
                setAbout(response.data);
            } catch (error) {
                console.error('Failed to fetch about content:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchAbout();
    }, []);

    if (loading || !about || !about.is_active) return null;

    return (
        <section id="about-us" className="py-24 bg-white overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-2 gap-16 items-center">
                    {/* Image Side */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        className="relative"
                    >
                        <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl relative z-10">
                            {about.image_url ? (
                                <img
                                    src={about.image_url}
                                    alt={about.title}
                                    className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                                />
                            ) : (
                                <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                                    <span className="text-gray-400">Image not available</span>
                                </div>
                            )}
                        </div>
                        {/* Decorative elements */}
                        <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-orange-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
                        <div className="absolute -top-6 -left-6 w-32 h-32 bg-yellow-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                    </motion.div>

                    {/* Content Side */}
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                    >
                        <span className="text-[#E31E24] font-black uppercase tracking-[0.2em] text-[10px] mb-4 block">Our Heritage</span>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                            {about.title}
                        </h2>
                        <div className="space-y-6">
                            <p className="text-gray-600 text-lg leading-relaxed whitespace-pre-line">
                                {about.description}
                            </p>
                        </div>

                        <div className="mt-12 grid grid-cols-2 gap-8 border-t border-gray-100 pt-12">
                            <div>
                                <h4 className="text-gray-900 font-bold text-lg mb-2">100% Organic</h4>
                                <p className="text-gray-500 text-sm">Naturally raised with no antibiotics or added hormones.</p>
                            </div>
                            <div>
                                <h4 className="text-gray-900 font-bold text-lg mb-2">Fresh Daily</h4>
                                <p className="text-gray-500 text-sm">Processed and delivered within 24 hours of harvest.</p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
